export default __webpack_public_path__ + "static/media/RoyalMail.13fee1a4.svg";